import * as menu from '@/core/utils/menu.js';
import breadcrumbs from '@/core/utils/breadcrumbs.js';
import testsHelpers from '@/core/utils/testsHelpers.js';
import {splitToChunks} from '@/core/utils/splitToChunks';
import {getFormattedCurrencyRate} from '@/core/utils/getFormattedCurrencyRate';
import {concatObjectsWithReplacement} from '@/core/utils/concatObjectsWithReplacement';

export {
    menu,
    breadcrumbs,
    testsHelpers,
    splitToChunks,
    getFormattedCurrencyRate,
    concatObjectsWithReplacement,
};
